import { routes } from '@routes';

const loginPagePathnames = routes.login.slice(0, 1) as string[];

export const isOnLoginPage = () =>
  loginPagePathnames.some((name) => window.location.pathname.includes(name));
